<script setup>
import { computed } from 'vue';
import { BaseEdge, getSmoothStepPath } from '@vue-flow/core';
import { useI18n } from 'vue-i18n';
import Button from 'dashboard/components-next/button/Button.vue';
import en from './en.json';
import ru from './ru.json';

const props = defineProps({
  id: { type: String, required: true },
  sourceX: { type: Number, required: true },
  sourceY: { type: Number, required: true },
  targetX: { type: Number, required: true },
  targetY: { type: Number, required: true },
  sourcePosition: { type: String, required: true },
  targetPosition: { type: String, required: true },
  markerEnd: { type: String, default: undefined },
  data: { type: Object, default: () => ({}) },
  selected: { type: Boolean, default: false },
});
const emit = defineEmits(['insert']);
const { t } = useI18n({ useScope: 'local', messages: { en, ru } });
const path = computed(() =>
  getSmoothStepPath({
    sourceX: props.sourceX,
    sourceY: props.sourceY,
    targetX: props.targetX,
    targetY: props.targetY,
    sourcePosition: props.sourcePosition,
    targetPosition: props.targetPosition,
  })
);
</script>

<template>
  <BaseEdge
    :id="id"
    :path="path[0]"
    :marker-end="markerEnd"
    :interaction-width="24"
    :class="
      data.highlighted
        ? '!stroke-n-teal-9 !stroke-2'
        : selected
          ? '!stroke-n-brand !stroke-2'
          : '!stroke-n-slate-7'
    "
  />
  <foreignObject :x="path[1] - 20" :y="path[2] - 20" width="40" height="40">
    <Button
      icon="i-lucide-plus"
      variant="outline"
      color="slate"
      class="nodrag nopan !size-9 !bg-n-solid-1 !rounded-full"
      :aria-label="t('editor.insertStep')"
      :title="t('editor.insertStep')"
      @click.stop="emit('insert', id)"
    />
  </foreignObject>
</template>
